const TmpPE016 = (page) => {
  const images = [];
  const media = [];
  const modifiedPage = {
    ...page
  };

  page.content.core.forEach((observation, index) => {
    // modify the media object from the page data
    const observationMedia = {
      size: '960px X 540px',
      ...observation.media,
      id: page.id + '-' + index,
      page: page.id,
      src: page.label.toLowerCase().replaceAll('-', '_') + '_' + index + '.jpg'
    };
    // add the media object to the media array
    media.push(observationMedia);
    // modify the media object to strip out the unnecessary data
    delete observationMedia.author_desc_en;
    delete observationMedia.author_desc_tl;
    delete observationMedia.transcript;
    delete observationMedia.display_content;
    delete observationMedia.media_url;
    // push the modified media object to the images array
    // images.push(observationMedia);
    // update the media object in te modified page data
    modifiedPage.content.core[index].media = observationMedia;

    modifiedPage.content.core[index].section_id = page.id;
  });

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: page.materialsData || [],
    eMentor: page.eMentorData || [],
    focusPoints: page.focusPointsData || []
  };

  return { modifiedPage, metadata };
};

export default TmpPE016;
